<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Consultas — Alvarás à vencer
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta consulta lista cadastros econômicos cujo
        strong  alvará
        |  vence no período informado.

      .toast.toast-primary
        | Exige a permissão
        strong  Consulta → Cadastros → Alvarás à vencer → Listar
        | .

      h5.h5 1. Abrir Alvarás à Vencer
      ol
        li Em
          strong  Consultas
          | , clique em
          strong  Alvarás à Vencer
          | .

      h5.h5 2. Filtrar
      p
        | Por padrão o sistema sugere um intervalo de vencimento
        |  (data atual até cerca de um mês à frente). Você pode ajustar:
      ol
        li
          strong  Cadastro
          |  — número do cadastro.
        li
          strong  Vencimento inicial / final
          |  — intervalo do alvará.
        li
          strong  CPF/CNPJ
          |  do contribuinte.
        li
          strong  Patrimonio
          |  e
          strong  Situação lote
          | .
        li Clique na
          strong  lupa
          |  para filtrar.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de alvarás à vencer")

      h5.h5 3. Resultado e abrir cadastro
      p
        | A tabela mostra número do cadastro, dados do alvará, situação,
        |  CPF/CNPJ, razão social e cadastro imobiliário.
      ol
        li Use a paginação se houver várias páginas.
        li Clique no ícone de
          strong  olho
          |  (
          em Exibir
          | ) para abrir o cadastro correspondente
          |  (mesma tela de
          strong  Consultas → Cadastros
          | ).

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/21-consultas-alvaras-vencer-lista.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
